import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const ifAuthenticated = (to, from, next) => {
  if (!localStorage.getItem('userData'))
    next({
      path: '/login'
    });
  else
    next();
};
const NotAuthenticated = (to, from, next) => {
  if (localStorage.getItem('userData'))
    next({
      path: '/'
    });
  else next();
};


const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/dashboard/Dashboard.vue'),
      beforeEnter: ifAuthenticated,
      meta: {
        pageTitle: 'Dashboard',
        breadcrumb: [
          {
            text: 'Dashboard',
            active: true,
          },
        ],
      },
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: () => import('@/views/dashboard/Dashboard.vue'),
      beforeEnter: ifAuthenticated,
      meta: {
        pageTitle: 'Dashboard',
        breadcrumb: [
          {
            text: 'Dashboard',
            active: true,
          },
        ],
      },
    },
    // **********************************************************BEGIN SHOP **************************************************************
    {
      path: '/sale/quotations',
      name: 'sale-quotation',
      component: () => import('@/views/sale/quote/Quote.vue'),
      beforeEnter: ifAuthenticated,
      meta: {
        pageTitle: 'Sale',
        breadcrumb: [
          {
            text: 'Quotations list',
            active: true,
          },
        ],
      },
    },
    {
      path: '/sale/quotations/add',
      name: 'add-sale-quotation',
      component: () => import('@/views/sale/quote/QuoteAdd.vue'),
      beforeEnter: ifAuthenticated,
      meta: {
        pageTitle: 'Sale',
        breadcrumb: [
          {
            text: 'Add quotation',
            active: true,
          },
        ],
      },
    },
    {
      path: '/sale/quotations/edit',
      name: 'edit-sale-quotation',
      component: () => import('@/views/sale/quote/QuoteEdit.vue'),
      beforeEnter: ifAuthenticated,
      meta: {
        pageTitle: 'Sale',
        breadcrumb: [
          {
            text: 'Edit quotation',
            active: true,
          },
        ],
      },
    },
    {
      path: '/sale/quotations/booking',
      name: 'booking',
      component: () => import('@/views/sale/quote/Booking.vue'),
      beforeEnter: ifAuthenticated,
      meta: {
        pageTitle: 'Sale',
        breadcrumb: [
          {
            text: 'Booking',
            active: true,
          },
        ],
      },
    },
    {
      path: '/sale/quotations/booking/quotation-detail',
      name: 'booking',
      component: () => import('@/views/sale/quote/QuoteDetail.vue'),
      beforeEnter: ifAuthenticated,
      meta: {
        pageTitle: 'Sale',
        breadcrumb: [
          {
            text: 'Booking',
            active: true,
          },
          {
            text: 'Detailed Quotation',
            active: false,
          },
        ],
      },
    },
    {
      path: '/sale/booking/edit',
      name: 'edit-sale-booking',
      component: () => import('@/views/sale/quote/BookingEdit.vue'),
      beforeEnter: ifAuthenticated,
      meta: {
        pageTitle: 'Sale',
        breadcrumb: [
          {
            text: 'booking',
            to: { name: 'booking' },
          },
          {
            text: 'Edit booking',
            active: true,
          },
        ],
      },
    },
    {
      path: '/sale/quotations/booking-settings',
      name: 'booking-quotation',
      component: () => import('@/views/sale/quote/BookingSettings.vue'),
      beforeEnter: ifAuthenticated,
      meta: {
        pageTitle: 'Sale',
        breadcrumb: [
          {
            text: 'Booking',
            active: true,
          },
        ],
      },
    },
    {
      path: '/data-management',
      name: 'data-management',
      component: () => import('@/views/sale/data/data-management-containers.vue'),
      beforeEnter: ifAuthenticated,
      meta: {
        pageTitle: 'Sales',
        breadcrumb: [
          {
            text: 'Data management',
            active: true,
          },
        ],
      },
    },
    {
      path: '/agency-data-management',
      name: 'agency-data-management',
      component: () => import('@/views/sale/data/data-management-agency.vue'),
      beforeEnter: ifAuthenticated,
      meta: {
        pageTitle: 'Sales',
        breadcrumb: [
          {
            text: 'Data management',
            active: true,
          },
        ],
      },
    },
    {
      path: '/commodity-data-management',
      name: 'commodity-data-management',
      component: () => import('@/views/sale/data/data-management-commodity.vue'),
      beforeEnter: ifAuthenticated,
      meta: {
        pageTitle: 'Sales',
        breadcrumb: [
          {
            text: 'Data management',
            active: true,
          },
        ],
      },
    },
    {
      path: '/voyage-data-management',
      name: 'voyage-data-management',
      component: () => import('@/views/sale/data/data-management-voyage.vue'),
      beforeEnter: ifAuthenticated,
      meta: {
        pageTitle: 'Sales',
        breadcrumb: [
          {
            text: 'Data management',
            active: true,
          },
        ],
      },
    },
    {
      path: '/detail-voyage',
      name: 'detail-voyage',
      component: () => import('@/views/voyage/DetailVoyage.vue'),
      beforeEnter: ifAuthenticated,
      meta: {
        pageTitle: 'Sales',
        breadcrumb: [
          {
            text: 'Data management',
            active: false,
          },
          {
            text: 'Detailed Voyage',
            active: true,
          },
        ],
      },
    },  
    {
      path: '/edit-voyage',
      name: 'edit-voyage',
      component: () => import('@/views/voyage/UpdateVoyage.vue'),
      beforeEnter: ifAuthenticated,
      meta: {
        pageTitle: 'Sales',
        breadcrumb: [
          {
            text: 'Data management',
            active: false,
          },
          {
            text: 'Edit Voyage',
            active: true,
          },
        ],
      },
    }, 
    {
      path: '/list-bookings',
      name: 'list-bookings',
      component: () => import('@/views/sale/quote/VoyageBookings.vue'),
      beforeEnter: ifAuthenticated,
      meta: {
        pageTitle: 'Sales',
        breadcrumb: [
          {
            text: 'Data management',
            active: false,
          },
          {
            text: 'Bookings',
            active: true,
          },
        ],
      },
    },
    {
      path: '/vessel-data-management',
      name: 'vessel-data-management',
      component: () => import('@/views/sale/data/data-management-vessel.vue'),
      beforeEnter: ifAuthenticated,
      meta: {
        pageTitle: 'Sales',
        breadcrumb: [
          {
            text: 'Data management',
            active: true,
          },
        ],
      },
    },
    {
      path: '/other-data-management',
      name: 'other-data-management',
      component: () => import('@/views/sale/data/data-management-other.vue'),
      beforeEnter: ifAuthenticated,
      meta: {
        pageTitle: 'Sales',
        breadcrumb: [
          {
            text: 'Data management',
            active: true,
          },
        ],
      },
    },
    {
      path: '/quotations/guide-line',
      name: 'guide-line-quotation',
      component: () => import('@/views/sale/instant-estimation/GuidLine.vue'),
      beforeEnter: ifAuthenticated,
      meta: {
        pageTitle: 'Sales',
        breadcrumb: [
          {
            text: 'Guide Line',
            active: true,
          },
        ],
      },
    },
    {
      path: '/quotations/guide-line-list',
      name: 'guide-line-list',
      component: () => import('@/views/sale/instant-estimation/GuidLineList.vue'),
      beforeEnter: ifAuthenticated,
      meta: {
        pageTitle: 'Sales',
        breadcrumb: [
          {
            text: 'Guide Line',
            active: true,
          },
        ],
      },
    },
    {
      path: '/quotations/guide-line-edit',
      name: 'guide-line-edit',
      component: () => import('@/views/sale/instant-estimation/GuidLineEdit.vue'),
      beforeEnter: ifAuthenticated,
      meta: {
        pageTitle: 'Sales',
        breadcrumb: [
          {
            text: 'Guide Line',
            active: true,
          },
        ],
      },
    },
    {
      path: '/bl',
      name: 'bl',
      component: () => import('@/views/sale/bl/bl.vue'),
      beforeEnter: ifAuthenticated,
      meta: {
        pageTitle: 'B/L',
        breadcrumb: [
          {
            text: 'B/L',
            active: true,
          },
        ],
      },
    },
    {
      path: '/bl/booking-detail',
      name: 'booking-detail',
      component: () => import('@/views/sale/bl/BookingDetail.vue'),
      beforeEnter: ifAuthenticated,
      meta: {
        pageTitle: 'B/L',
        breadcrumb: [
          {
            text: 'B/L',
            active: true,
          },
          {
            text: 'Detailed Booking',
            active: false,
          },
        ],
      },
    },
    {
      path: '/bl/edit',
      name: 'bl-edit',
      component: () => import('@/views/sale/bl/blEdit.vue'),
      beforeEnter: ifAuthenticated,
      meta: {
        pageTitle: 'B/L',
        breadcrumb: [
          {
            text: 'B/L edit',
            active: true,
          },
        ],
      },
    },
    // **********************************************************End SHOP **************************************************************
    // **********************************************************BEGIN INSTANT ESTIMATION **************************************************************
    {
      path: '/instant-estimation',
      name: 'instant-estimation',
      component: () => import('@/views/sale/instant-estimation/InstantEstimation.vue'),
      beforeEnter: ifAuthenticated,
      meta: {
        pageTitle: 'instant estimation list',
        breadcrumb: [
          {
            text: 'instant estimation list',
            active: true,
          },
        ],
      },
    },
    {
      path: '/instant-estimation/edit',
      name: 'instant-estimation-edit',
      component: () => import('@/views/sale/instant-estimation/InstantEstimationEdit.vue'),
      beforeEnter: ifAuthenticated,
      meta: {
        pageTitle: 'instant estimation edit',
        breadcrumb: [
          {
            text: 'instant estimation edit',
            active: true,
          },
        ],
      },
    },
    // **********************************************************END INSTANT ESTIMATION **************************************************************
    // **********************************************************BEGIN schedule **************************************************************
    {
      path: '/schedule',
      name: 'schedule',
      component: () => import('@/views/schedule/Schedule.vue'),
      beforeEnter: ifAuthenticated,
      meta: {
        pageTitle: 'Schedule Settings',
        breadcrumb: [
          {
            text: 'schedule Settings',
            active: true,
          },
        ],
      },
    },
    // **********************************************************END schedule **************************************************************
    // **********************************************************BEGIN USERS **************************************************************
    {
      path: '/customers',
      name: 'customers',
      component: () => import('@/views/customer/Customer.vue'),
      beforeEnter: ifAuthenticated,
      meta: {
        pageTitle: 'Clients',
        breadcrumb: [
          {
            text: 'Clients list',
            active: true,
          },
        ],
      },
    },
    {
      path: '/customers/edit',
      name: 'customers-edit',
      component: () => import('@/views/customer/EditClient.vue'),
      beforeEnter: ifAuthenticated,
      meta: {
        pageTitle: 'Clients',
        breadcrumb: [
          {
            text: 'Clients list',
            active: true,
          },
        ],
      },
    },
    {
      path: '/agents',
      name: 'agents',
      component: () => import('@/views/agent/Agent.vue'),
      beforeEnter: ifAuthenticated,
      meta: {
        pageTitle: 'Agents',
        breadcrumb: [
          {
            text: 'Agents list',
            active: true,
          },
        ],
      },
    },
    {
      path: '/agents/edit',
      name: 'agents-edit',
      component: () => import('@/views/agent/EditAgent.vue'),
      beforeEnter: ifAuthenticated,
      meta: {
        pageTitle: 'agents',
        breadcrumb: [
          {
            text: 'agents list',
            active: true,
          },
        ],
      },
    },
    {
      path: '/admins',
      name: 'admins',
      component: () => import('@/views/admin/Admin.vue'),
      beforeEnter: ifAuthenticated,
      meta: {
        pageTitle: 'Admins',
        breadcrumb: [
          {
            text: 'Liste des admins',
            active: true,
          },
        ],
      },
    },
    // **********************************************************END USERS **************************************************************
     {
      path: '/contact',
      name: 'contact',
       component: () => import('@/views/contact/Contact.vue'),
      beforeEnter: ifAuthenticated,

      meta: {
        pageTitle: 'Contact',
        breadcrumb: [
          {
            text: 'Contact',
            active: true,
          },
        ],
      },
    },
    {
      path: '/settings',
      name: 'settings',
      component: () => import('@/views/account-setting/AccountSetting.vue'),
      beforeEnter: ifAuthenticated,

      meta: {
        pageTitle: 'Settings',
        breadcrumb: [
          {
            text: 'Settings',
            active: true,
          },
        ],
      },
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/auth/Login.vue'),
      beforeEnter: NotAuthenticated,

      meta: {
        layout: 'full',
      },
    },
    {
      path: '/ForgotPassword',
      name: 'forgot-password',
      component: () => import('@/views//auth/ForgotPassword.vue'),
      beforeEnter: NotAuthenticated,

      meta: {
        layout: 'full',
      },
    },
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      beforeEnter: NotAuthenticated,

      meta: {
        layout: 'full',
      },
    },
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})



export default router;
